// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"bbd3533e","208":"142bd4fb","236":"a2504840","353":"aebc2cf8","512":"0165dbeb","549":"f3f17168","813":"2c89f1c0"}[chunkId] + ".chunk.js";
};